import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import { useCallback } from 'react'

import { assetListActionsStatusSlice } from '../store'

export const useActionsStatus = () => {
  const { isEnable: isEnableForRegisterAcceleratedDepreciation } = useCheckFlag(
    FeatureFlagNames.RegisterAcceleratedDepreciation
  )

  const actionsStatus = assetListActionsStatusSlice.useSlice(state => state?.data?.action_status)

  const getActionsStatus = useCallback(
    (biids: string[]) => {
      isEnableForRegisterAcceleratedDepreciation && assetListActionsStatusSlice.setFilters({ biids }, true)
    },
    [isEnableForRegisterAcceleratedDepreciation]
  )

  const findActionsStatusByBiid = useCallback(
    (biid: string) => actionsStatus?.find(actionStatus => actionStatus.biid === biid),
    [actionsStatus]
  )

  return { actionsStatus, getActionsStatus, findActionsStatusByBiid }
}
